

export const AUDIO_EXTENSIONS = [
  'aiff',
  'au',
  'flac',
  'm4a',
  'mid',
  'mp3',
  'oga',
  'ogg',
  'opus',
  'wav',
  'weba',
  'webm',
  'wma',
];

export const IMAGE_EXTENSIONS = [
  'avif',
  'bmp',
  'gif',
  'ico',
  'jfif',
  'jpg',
  'jpeg',
  'jxl',
  'pjp',
  'pjpeg',
  'png',
  'svgz',
  'tif',
  'tiff',
  'xbm',
  'svg',
  'webp',
];

export const VIDEO_EXTENSIONS = [
  'asx',
  'avi',
  'm4v',
  'mov',
  'mp4',
  'mpeg',
  'mpg',
  'ogm',
  'ogv',
  'wmv',
];

export const WORD_EXTENSIONS = ['doc', 'docx'];

export const POWERPOINT_EXTENSIONS = ['pps', 'ppt', 'ppsx', 'pptx'];

export const EXCEL_EXTENSIONS = ['xls', 'xlsx'];

export const EML_EXTENSIONS = ['eml'];

export const PDF_EXTENSIONS = ['pdf'];